import React from 'react';
import { connect } from 'react-redux';
import { message, notification, Button, Space } from 'antd';
import PropTypes from 'prop-types';
import * as notificationActions from '../actions/notifications';
import isEqual from 'lodash.isequal';
import { GlobalConfigContext } from './Config/GlobalConfigContext';
import { withRouter } from 'react-router-dom';
const { notifyDismiss, notifyUpdate } = notificationActions;
class Notifications extends React.PureComponent {
	static contextType = GlobalConfigContext;
	constructor(props) {
		super(props);
		this.state = {};
		
		message.config({
			top: 50,
			//duration: 2,
		});
		
		notification.config({
			placement: 'topRight',
			bottom: 50,
			//duration: 3,
		});
	}
    viewNotification = (notification) => {
        //const notification = e.target.value;
        const { history } = this.props;
        if(notification){
            //console.log(`notification:`, notification)
            this.context.notifications.notifyClose(notification.id);
            if(notification.url){
                history.push(notification.url);
            }
        }
    }
    closeNotification = (notification) => {
        if(notification){
            this.context.notifications.notifyClose(notification.id);
        }
    }
	componentDidUpdate(prevProps) {
		const { notifications, dispatch } = this.props;
		//console.log(notifications);
		if(!isEqual(notifications, prevProps.notifications)){
			notifications.map((notif) => {
				//console.log(`notif:`, notif);

                const messageType = notif && notif.message && notif.message.type ? 'component' : 'html';

				//console.log(notification);
				if(notif.closeFn === undefined){
					switch(notif.type || 'message'){
						case "notification":

                            const options = notif.options;
                            if(notif.url){
                                //console.log(`notif:`, notif)
                                options.btn = <Space>
                                    <Button onClick={() => this.closeNotification(notif)} type="danger" ghost value={notif}>{this.context.intl.formatMessage({ id: 'messages.menu.close', defaultMessage: 'CLOSE' }) }</Button>
                                    <Button onClick={() => this.viewNotification(notif)} type="primary" value={notif}>{this.context.intl.formatMessage({ id: 'messages.menu.view', defaultMessage: 'VIEW' }) }</Button>
                                </Space>
                            }

                            if(notif.kind){
                                notification[notif.kind]({
                                    key: notif.id,
                                    message: <span dangerouslySetInnerHTML={{__html:notif.title || '' }} />,
                                    description: messageType === 'html' ? <span dangerouslySetInnerHTML={{__html:notif.message || '' }} /> : notif.message,
                                    //getContainer: () => document.getElementById('layout-container'),
                                    ...options
                                });
                            }else{
                                notification.open({
                                    key: notif.id,
                                    message: <span dangerouslySetInnerHTML={{__html:notif.title || '' }} />,
                                    description: messageType === 'html' ? <span dangerouslySetInnerHTML={{__html:notif.message || '' }} /> : notif.message,
                                    //getContainer: () => document.getElementById('layout-container'),
                                    ...options
                                });
                            }							
							dispatch(notifyDismiss(notif.id));
						break;
						default:
							switch(notif.kind || 'info'){
								case "error":
									message.error(<span dangerouslySetInnerHTML={{__html:notif.title || '' }} />, (notif.options && notif.options.duration) || 1.5);
									dispatch(notifyDismiss(notif.id));
								break;
								case "success":
									message.success(<span dangerouslySetInnerHTML={{__html:notif.title || '' }} />, (notif.options && notif.options.duration) || 1.5);
									dispatch(notifyDismiss(notif.id));
								break;
								case "warning":
									message.warning(<span dangerouslySetInnerHTML={{__html:notif.title || '' }} />, (notif.options && notif.options.duration) || 1.5);
									dispatch(notifyDismiss(notif.id));
								break;
								case "loading":
									//console.log('loading');
									const messageFn = message.loading(notif.title, 0);
									//dispatch(notifyDismiss(notif.id));
									dispatch(notifyUpdate(notif.id, messageFn));
								break;
								default:
									message.info(<span dangerouslySetInnerHTML={{__html:notif.title || '' }} />, (notif.options && notif.options.duration) || 1.5);
									dispatch(notifyDismiss(notif.id));
							}
					}
				}
				return notif;
			});
		}
	}
	onClose = (id) => {
		const { dispatch } = this.props;
		//console.log(id);
		dispatch(notifyDismiss(id));
	}
	render() {
		return null;
	}
}

Notifications.defaultProps = {
	className: null,
	componentClassName: 'notif',
};

Notifications.propTypes = {
	//notifications: PropTypes.array.isRequired,
	dispatch: PropTypes.func.isRequired,
	className: PropTypes.string,
	componentClassName: PropTypes.string
};

function mapStateToProps(state) {
	return { notifications: state.get ? state.get('notifications') : state.notifications };
}

export default withRouter(connect(mapStateToProps)(Notifications));